import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./api";

const KEY = ["admin", "companies"] as const;

/** 公司列表。仅 super_admin 有权限, company_admin 请求会 403 —— 用
 *  enabled=false 直接不发请求, 而不是发出去再吞掉错误。 */
export function useCompanies(enabled = true) {
  return useQuery({ queryKey: KEY, queryFn: api.listCompanies, enabled });
}

export function useCreateCompany() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.createCompany,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateCompany() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: { id: number; payload: api.UpdateCompanyPayload }) =>
      api.updateCompany(v.id, v.payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteCompany() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.deleteCompany,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
